'use es6';

import { fromJS } from 'immutable';
import I18n from 'I18n';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
export const getAccountNameFromNavigation = basicSelectorWithStats(() => {
  const navConfig = fromJS(hubspot.navigation || {}); // eslint-disable-line

  return navConfig.getIn(['portal', 'accountName'], I18n.text('onboarding.shepherd.fallbackFromName'));
});